import React, {Component} from 'react';
import PropTypes from 'prop-types';

const BigButton = ({ onClick, children, ...other }) => (
    <button onClick={onClick} {...other}>
        {children}
    </button>
);

BigButton.propTypes = {
    onClick: PropTypes.func.isRequired
}

export default BigButton;